import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '../model/types'

type AuthState = {
  user: User | null | undefined
}



const initialState: AuthState = {
  user: undefined
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload
    }
  }
})

export const { setUser } = authSlice.actions

export default authSlice.reducer
